// paquetes
import {useLocation, useNavigate, useOutletContext} from 'react-router-dom';
import React, {useState, useEffect } from "react";
import axios from "axios";
// componentes
import ZonaCargando from '../../alertas/zonaCargando';
import CardServicio from '../../../componentesEspeciales/cardServicio';
// estilos
import '../../../estilos/usuario.css';



function PagoIndividualComprador() {
    const { usuario, setUsuario, cargandoUsuario } = useOutletContext() || {}; // variables que vienen de direccionameinto 
    const navigate                      = useNavigate();
    const location = useLocation();

    const idReserva = location?.state?.idReserva;
    
    // Variables
    const [cargando, setCargando]  = useState(false);
    const cargandoFinal            = Boolean(cargandoUsuario) || Boolean(cargando);

    const [reserva, setReserva] = useState(null);
    const [servicio, setServicio] = useState(null);
    const [transaccion, setTransaccion] = useState(null);

    useEffect(() => {
        (async () => {
            if (cargandoUsuario) return; // Espera a que Direccionamiento termine de cargar sesión

            // Si no hay usuario, esta página requiere login
            if (!usuario) { return navigate("/iniciar-sesion"); }

            // Hidratamos el perfil desde el usuario global
            try {
                setCargando(true);
                // buscamos esta reserva en específico
                const resReserva = await axios.post("/obtener-reserva-comprador", {
                    params: {
                        idUsuario: usuario.idUsuario,
                        idReserva,
                        tipo: "COMPRADOR",
                    }
                });

                const reservaEncontrada = resReserva?.data?.reserva || null;
                const servicioEncontrado = resReserva?.data?.servicio || null;

                setReserva(reservaEncontrada);
                setServicio(servicioEncontrado);
                // BUSCAMOS LA TRANSACCIÓN EN WOMPI
                const idPago = reservaEncontrada?.cobro?.idPago;

                if (idPago) {
                    const resTransaccion = await axios.post("/obtener-datos-transaccion", {
                        params: {
                            idTransaccion: idPago,
                        }
                    });

                    setTransaccion(resTransaccion?.data?.transaccion || null);
                }
                else { setTransaccion(null); }
            }
            finally { setCargando(false); }
        })();
    }, [usuario, cargandoUsuario, idReserva, navigate]);
    



    

    const formatearMoneda = (valor, moneda = 'COP') => {
        const numero = Number(valor || 0);
        return numero.toLocaleString('es-CO', {
            style: 'currency',
            currency: moneda,
            maximumFractionDigits: 0,
        });
    };

    const formatearFecha = (valor) => {
        if (!valor) return 'No disponible';
        const fecha = new Date(valor);
        if (Number.isNaN(fecha.getTime())) return 'No disponible';
        return fecha.toLocaleString('es-CO', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        });
    };

    const monedaTransaccion = transaccion?.currency || reserva?.cobro?.moneda || 'COP';
    const montoTransaccion  = transaccion?.amount_in_cents ? transaccion.amount_in_cents / 100 : null;
    const metodoPago        = transaccion?.payment_method_type || transaccion?.payment_method?.type || reserva?.cobro?.metodoPagoTipo || 'No disponible';
    const estadoPago        = transaccion?.status || reserva?.cobro?.estadoPago || 'No disponible';




    return(
    <div >
    { (cargandoFinal) ? <ZonaCargando />
    :  usuario ? 
    <div className='d-flex flex-row '>
        {/* Columna 2 */}
        <div className="flex-grow-1 container-fluid contenedorAdaptador ">     
            {/* Contenedor título  */}
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom border-dark">
                <div className="container">
                    <div className="d-flex justify-content-between align-items-center flex-wrap">
                        {/* título */}
                        <h1 className="h2 text-dark mb-0">Ver pago</h1>
                    </div>
                </div>
            </div>
            
            {!idReserva ? <div className='container'>
                <p>No encontramos la reserva que deseas consultar. Por favor vuelve a la página de pagos para seleccionar una compra válida.</p>
                <button type='button' className='btn btn-outline-dark rounded-pill px-4' onClick={() => navigate('/usuario/pagos')} >
                    Volver a pagos
                </button>
            </div> :
            <div className='container pb-4'>
                {servicio ?
                <div className='mb-4'>
                    <div className='d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2'>
                        <h3 className='text-dark mb-0'>Servicio comprado</h3>
                        <button
                            type='button'
                            className='btn btn-outline-dark rounded-pill px-4'
                            onClick={() => navigate('/usuario/pagos')}
                        >
                            Volver a pagos
                        </button>
                    </div>
                     <CardServicio
                        servicio={servicio}
                        clampDesc={4}
                        textoBoton="Ver servicio"
                        desdeDonde={"pagos"}
                    />
                </div>
                : null}

                <div className='card shadow-sm border-0 rounded-4 overflow-hidden'>
                    <div className='card-body p-4 p-md-5'>
                        <div className='d-flex justify-content-between align-items-center flex-wrap gap-2 mb-4'>
                            <div>
                                <p className='text-muted mb-1'>Transacción</p>
                                <h3 className='text-dark mb-0'>Detalle del pago</h3>
                            </div>
                            <span className='badge text-bg-dark px-3 py-2 rounded-pill text-uppercase'>{estadoPago}</span>
                        </div>

                        <div className='row g-4'>
                            <div className='col-12 col-md-6 col-xl-3'>
                                <div className='border rounded-4 p-3 h-100 bg-light'>
                                    <p className='text-muted mb-1'>Monto pagado</p>
                                    <h5 className='mb-0 text-dark'>
                                        {montoTransaccion !== null ? formatearMoneda(montoTransaccion, monedaTransaccion) : 'No disponible'}
                                    </h5>
                                </div>
                            </div>

                            <div className='col-12 col-md-6 col-xl-3'>
                                <div className='border rounded-4 p-3 h-100 bg-light'>
                                    <p className='text-muted mb-1'>Método de pago</p>
                                    <h5 className='mb-0 text-dark text-uppercase'>{metodoPago}</h5>
                                </div>
                            </div>

                            <div className='col-12 col-md-6 col-xl-3'>
                                <div className='border rounded-4 p-3 h-100 bg-light'>
                                    <p className='text-muted mb-1'>ID transacción</p>
                                    <h6 className='mb-0 text-dark' style={{ wordBreak: 'break-word' }}>{transaccion?.id || reserva?.cobro?.idPago || 'No disponible'}</h6>
                                </div>
                            </div>

                            <div className='col-12 col-md-6 col-xl-3'>
                                <div className='border rounded-4 p-3 h-100 bg-light'>
                                    <p className='text-muted mb-1'>Moneda</p>
                                    <h5 className='mb-0 text-dark text-uppercase'>{monedaTransaccion}</h5>
                                </div>
                            </div>
                        </div>

                        <div className='row g-4 mt-1'>
                            <div className='col-12 col-lg-6'>
                                <div className='border rounded-4 p-4 h-100'>
                                    <h5 className='text-dark mb-3'>Información general</h5>
                                    <div className='row g-3'>
                                        <div className='col-12 col-md-6'>
                                            <p className='text-muted mb-1'>Fecha de creación</p>
                                            <p className='mb-0 text-dark'>{formatearFecha(transaccion?.created_at)}</p>
                                        </div>
                                        <div className='col-12 col-md-6'>
                                            <p className='text-muted mb-1'>Fecha finalizada</p>
                                            <p className='mb-0 text-dark'>{formatearFecha(transaccion?.finalized_at)}</p>
                                        </div>
                                        <div className='col-12 col-md-6'>
                                            <p className='text-muted mb-1'>Referencia</p>
                                            <p className='mb-0 text-dark' style={{ wordBreak: 'break-word' }}>{transaccion?.reference || 'No disponible'}</p>
                                        </div>
                                        <div className='col-12 col-md-6'>
                                            <p className='text-muted mb-1'>Mensaje de estado</p>
                                            <p className='mb-0 text-dark'>{transaccion?.status_message || 'No disponible'}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div className='row g-4 mt-1'>
                            <div className='col-12 col-lg-6'>
                                <div className='border rounded-4 p-4 h-100'>
                                    <h5 className='text-dark mb-3'>Método de pago</h5>
                                    <div className='row g-3'>
                                        <div className='col-12 col-md-6'>
                                            <p className='text-muted mb-1'>Tipo</p>
                                            <p className='mb-0 text-dark text-uppercase'>{transaccion?.payment_method?.type || 'No disponible'}</p>
                                        </div>
                                        <div className='col-12 col-md-6'>
                                            <p className='text-muted mb-1'>Cuotas</p>
                                            <p className='mb-0 text-dark'>{transaccion?.payment_method?.installments ?? 'No disponible'}</p>
                                        </div>
                                        <div className='col-12 col-md-6'>
                                            <p className='text-muted mb-1'>Click to Pay</p>
                                            <p className='mb-0 text-dark'>{typeof transaccion?.payment_method?.is_click_to_pay === 'boolean' ? (transaccion.payment_method.is_click_to_pay ? 'Sí' : 'No') : 'No disponible'}</p>
                                        </div>
                                        <div className='col-12 col-md-6'>
                                            <p className='text-muted mb-1'>Payment source ID</p>
                                            <p className='mb-0 text-dark'>{transaccion?.payment_source_id || 'No disponible'}</p>
                                        </div>
                                        <div className='col-12'>
                                            <p className='text-muted mb-1'>Información extra</p>
                                            <pre className='mb-0 p-3 rounded-4 bg-light small' style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                            {JSON.stringify(transaccion?.payment_method?.extra || {}, null, 2)}
                                            </pre>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='col-12 col-lg-6'>
                                <div className='border rounded-4 p-4 h-100'>
                                    <h5 className='text-dark mb-3'>Datos técnicos y adicionales</h5>
                                    <div className='row g-3'>
                                        <div className='col-12 col-md-6'>
                                            <p className='text-muted mb-1'>Bill ID</p>
                                            <p className='mb-0 text-dark'>{transaccion?.bill_id || 'No disponible'}</p>
                                        </div>
                                        <div className='col-12 col-md-6'>
                                            <p className='text-muted mb-1'>Disbursement</p>
                                            <p className='mb-0 text-dark'>{transaccion?.disbursement || 'No disponible'}</p>
                                        </div>
                                        <div className='col-12 col-md-6'>
                                            <p className='text-muted mb-1'>Tip</p>
                                            <p className='mb-0 text-dark'>
                                                {transaccion?.tip_in_cents ? formatearMoneda(transaccion.tip_in_cents / 100, monedaTransaccion) : 'No disponible'}
                                            </p>
                                        </div>
                                        <div className='col-12 col-md-6'>
                                            <p className='text-muted mb-1'>Dirección de envío</p>
                                            <p className='mb-0 text-dark'>{transaccion?.shipping_address || 'No disponible'}</p>
                                        </div>
                                        <div className='col-12'>
                                            <p className='text-muted mb-1'>Taxes</p>
                                            <pre className='mb-0 p-3 rounded-4 bg-light small' style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                            {JSON.stringify(transaccion?.taxes || [], null, 2)}
                                            </pre>
                                        </div>
                                        <div className='col-12 col-md-6'>
                                            <p className='text-muted mb-1'>Refunds</p>
                                            <p className='mb-0 text-dark'>{Array.isArray(transaccion?.refunds) ? transaccion.refunds.length : 'No disponible'}</p>
                                        </div>
                                        <div className='col-12 col-md-6'>
                                            <p className='text-muted mb-1'>Entries</p>
                                            <p className='mb-0 text-dark'>{Array.isArray(transaccion?.entries) ? transaccion.entries.length : 'No disponible'}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>}
        </div>
    </div>
    : null
    }
    </div>  
    )
}
  
  
  
export default PagoIndividualComprador;